import Swiper from 'swiper/bundle'
import noUiSlider from 'nouislider'
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import Flickity from 'flickity'
import Scrollbar from 'smooth-scrollbar'
import Splide from '@splidejs/splide'
import * as Sentry from "@sentry/browser";
import {magnifierSetup} from './magnifier.js';

Alpine.plugin(collapse)
window.Swiper = Swiper
window.noUiSlider = noUiSlider
window.Flickity = Flickity
window.Alpine = Alpine
window.Scrollbar = Scrollbar
window.Splide = Splide
window.Sentry = Sentry


function carousel() {
    return {
        active: 0, init() {
            var flkty = new Flickity(this.$refs.carousel, {
                wrapAround: true
            })
            flkty.on('change', i => this.active = i)
        }
    }
}

function carouselFilter() {
    return {
        active: 0, changeActive(i) {
            this.active = i
            this.$nextTick(() => {
                let flkty = Flickity.data(this.$el.querySelectorAll('.carousel')[i])
                flkty.resize()
            })
        }
    }
}

window.toast = function (message, options = {}) {
    let description = ''
    let type = 'default'
    let position = 'top-center'
    let html = ''
    if (typeof options.description != 'undefined') description = options.description
    if (typeof options.type != 'undefined') type = options.type
    if (typeof options.position != 'undefined') position = options.position
    if (typeof options.html != 'undefined') html = options.html

    window.dispatchEvent(new CustomEvent('toast-show', {
        detail: {
            type: type, message: message, description: description, position: position, html: html
        }
    }))
}

function popToast(object, custom) {
    let html = ''
    if (typeof custom != 'undefined') {
        html = custom
    }
    toast(object.title, {description: object.description, type: object.type, position: object.position, html: html})
}

function tinymceAlpineSetup() {
    return {
        init() {
            this.$nextTick(() => this.initializeEditors())
        }, initializeEditors() {
            document.querySelectorAll('.my-tinymce-textarea').forEach((textarea) => {
                const instanceId = textarea.id
                console.log(instanceId, '1')
                // Ensure existing instances are removed
                if (tinymce.get(instanceId)) {
                    tinymce.get(instanceId).remove()
                }
                // Initialize TinyMCE for each textarea
                tinymce.init({
                    selector: `#${instanceId}`, // Your TinyMCE config...
                    setup: (editor) => {
                        editor.on('init', () => {
                            // Set initial content if needed
                            editor.setContent(this.value || '')
                        })
                        editor.on('change', () => {
                            // Update Livewire model or Alpine data
                            this.value = editor.getContent()
                            this.$dispatch('input', this.value)
                        })
                    },
                })
            })
        },
    }
}

let customScrollbars = document.querySelectorAll('.custom-scrollbar')

if (customScrollbars.length) {
    // 2. process all instances
    let scrollbar_options = {
        alwaysShowTracks: true
    }
    for (let i = 0; i < customScrollbars.length; i++) {
        let customScrollbarsElement = customScrollbars[i]

        // 3. mount/initialize this slider
        Scrollbar.init(customScrollbarsElement, scrollbar_options)
    }
}

function splideAssociations(object, custom) {
    if (document.querySelector('.splide-associations')) {
        var splideAssociations = new Splide('.splide-associations').mount()
        if (window.innerWidth <= 640) {

            splideAssociations.on('moved', function () {
                const currentIndex = splideAssociations.index
                const totalSlides = splideAssociations.Components.Elements.slides.length
                const splideContent = document.querySelector('.move-splide-content')
                const trackChildren = splideContent.children

                if (currentIndex === totalSlides - 2) {
                    splideContent.style.marginLeft = '-2.25rem'
                    trackChildren[0].style.marginLeft = '2.25rem'
                    splideAssociations.options = {
                        padding: {
                            right: '2.25rem', left: '3.5rem'
                        }
                    }
                    // Add any additional logic you need here
                } else {
                    splideContent.style.marginLeft = '0'
                    trackChildren[0].style.marginLeft = '0'
                    splideAssociations.options = {
                        padding: {
                            right: '3.5rem', left: '0'
                        }
                    }
                }
            })
        }
    }
}

Sentry.init({
    dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
    sendDefaultPii: true,
    integrations: [
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
            networkRequestHeaders: ["Cache-Control"],
            networkResponseHeaders: ["Referrer-Policy"]
        }),
        Sentry.browserTracingIntegration(),
        Sentry.replayCanvasIntegration(),
        Sentry.browserProfilingIntegration()
    ],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    profilesSampleRate: process.env.MIX_SENTRY_PROFILES_SAMPLE_RATE,
    tracesSampleRate: process.env.MIX_SENTRY_TRACES_SAMPLE_RATE
});


function sendConsentToGTM(consent) {
    window.dataLayer = window.dataLayer || [];

    function gtag() {
        dataLayer.push(arguments);
    }

    gtag('consent', 'update', {
        'ad_storage': consent.ad_storage,
        'analytics_storage': consent.analytics_storage,
        'functionality_storage': consent.functionality_storage,
        'personalization_storage': consent.personalization_storage,
        'security_storage': consent.security_storage,
        'ad_user_data': consent.ad_user_data,
        'ad_personalization': consent.ad_personalization
    });
}

function sendPurchaseEvent(data) {
    if (typeof gtag !== 'undefined') {
        gtag("event", "purchase", data);
    } else {
        console.warn('gtag not loaded');
    }
}

function sendViewItemEvent(data) {
    if (typeof gtag !== 'undefined') {
        gtag("event", "view_item", data);
    } else {
        console.warn('gtag not loaded');
    }
}

function sendBeginCheckoutEvent(data) {
    if (typeof gtag !== 'undefined') {
        gtag("event", "begin_checkout", data);
    } else {
        console.warn('gtag not loaded');
    }
}

function sendAddToCartEvent(data) {
    console.log('app js', data)
    if (typeof gtag !== 'undefined') {
        gtag("event", "add_to_cart", data);
    } else {
        console.warn('gtag not loaded');
    }
}

function sendRemoveFromCartEvent(data) {
    if (typeof gtag !== 'undefined') {
        gtag("event", "remove_from_cart", data);
    } else {
        console.warn('gtag not loaded');
    }
}

window.splideAssociations = splideAssociations
window.carousel = carousel
window.popToast = popToast
window.carouselFilter = carouselFilter
window.magnifierSetup = magnifierSetup
window.tinymceAlpineSetup = tinymceAlpineSetup
window.sendConsentToGTM = sendConsentToGTM
window.sendPurchaseEvent = sendPurchaseEvent
window.sendViewItemEvent = sendViewItemEvent
window.sendBeginCheckoutEvent = sendBeginCheckoutEvent
window.sendAddToCartEvent = sendAddToCartEvent
window.sendRemoveFromCartEvent = sendRemoveFromCartEvent
window.Sentry = Sentry

window.Alpine.start()

